import PageHeader from "core/components/Header/PageHeader";
import { _t } from "core/language";
import Icon from 'core/assets/icons';
import { AddRecipeByImageSwiperButton } from ".";

const AiChefHeader = ({handleGoBack}: {handleGoBack?: () => void}) => {
  return (
    <PageHeader
      title={_t('aiChef.recipe.title')}
      sticky
      className="bg-dark text-white"
      showCart={false}
      iconLeft={Icon.HeaderArrowLeftWhite}
      handleGoBack={handleGoBack}
      rightAction={<div className="relative">
        <AddRecipeByImageSwiperButton
          className="text-white w-[24px] h-[24px]"
        >
          <img src={Icon.BottomAiChef} alt="Icon BottomAiChef" />
        </AddRecipeByImageSwiperButton>
      </div>}
    />
  )
}

export default AiChefHeader
